import React from 'react';
import { Redirect } from 'react-router-dom';
import { hasFeature } from '../../services/permissions';

const RequireFeature = ({ feature, action = 'view', children }) => {
  if (!hasFeature(feature, action)) return <Redirect to="/home" />;
  return <>{children}</>;
};

export default RequireFeature;
